var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        width: "850px",
        height: "500px",
        title: "助教",
        loading: _vm.loading,
      },
      model: {
        value: _vm.config.visible,
        callback: function ($$v) {
          _vm.$set(_vm.config, "visible", $$v)
        },
        expression: "config.visible",
      },
    },
    [
      _c(
        "div",
        { staticClass: "AssistantDialog overflowOuto" },
        [
          _c("div", { staticClass: "titleName" }, [_vm._v("分配规则：")]),
          _c(
            "div",
            { staticClass: "cardText" },
            [
              _vm._v(" 每轮助教分配 "),
              _c("el-input-number", {
                attrs: {
                  precision: 0,
                  placeholder: "请输入内容",
                  "controls-position": "right",
                  size: "mini",
                  min: 1,
                  max: 500,
                },
                on: { change: _vm.handleChange },
                model: {
                  value: _vm.num,
                  callback: function ($$v) {
                    _vm.num = $$v
                  },
                  expression: "num",
                },
              }),
              _vm._v(
                " 名学生后，按更新时间顺序分给下一个被设置为自主分配的助教 "
              ),
            ],
            1
          ),
          _c("div", { staticClass: "titleName" }, [_vm._v("分配助教：")]),
          _c(
            "MPageLayout",
            {
              ref: "MPageLayout",
              attrs: {
                type: "tablePage",
                "slot-arr": _vm.slotArr,
                "current-page": _vm.currentPage,
                "page-sizes": _vm.pageSizes,
                "page-size": _vm.pageSize,
                total: _vm.total,
                "table-data": _vm.tableData,
                "table-columns": _vm.tableColumns,
                loading: _vm.loading,
                layout: "total, sizes, prev, pager, next, jumper",
                checkbox: "",
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
                handleSelectionChange: _vm.handleSelectionChange,
              },
            },
            [
              _c(
                "template",
                { slot: "search" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      attrs: { inline: true, model: _vm.search, size: "small" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "助教姓名", prop: "sysUserName" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: { clearable: "" },
                            on: { clear: _vm.searchFn },
                            model: {
                              value: _vm.search.sysUserName,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "sysUserName", $$v)
                              },
                              expression: "search.sysUserName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "自动分配", prop: "autoDistribute" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择", clearable: "" },
                              on: { clear: _vm.searchFn },
                              model: {
                                value: _vm.search.autoDistribute,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "autoDistribute", $$v)
                                },
                                expression: "search.autoDistribute",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "是", value: 1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "否", value: 0 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.searchFn },
                            },
                            [_vm._v("查询")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.clear },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("template", { slot: "footer" }),
            ],
            2
          ),
        ],
        1
      ),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }